import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { StorageService } from '../services/storage.service';

interface StoredLanguage {
  readonly code?: string;
}

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  private readonly storageService = inject(StorageService);

  public intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const storedUser = this.storageService.getUserData();
    const currentUser = storedUser.length > 0
      ? (JSON.parse(storedUser) as { token?: string; data?: { token?: string } })
      : null;
    const token = currentUser?.token ?? currentUser?.data?.token ?? '';

    if (token) {
      const storedLanguage = this.storageService.getSeletedLanguage();
      const language = storedLanguage.length > 0 ? (JSON.parse(storedLanguage) as StoredLanguage) : null;
      const languageCode = language?.code ?? 'EN-GB';
      request = this.addTokenHeader(request, token, languageCode);
    }

    return next.handle(request);
  }

  private addTokenHeader(request: HttpRequest<unknown>, token: string, language?: string): HttpRequest<unknown> {
    const headers: Record<string, string> = {
      Authorization: `Bearer ${token}`,
      'Time-zone': new Date().getTimezoneOffset().toString()
    };

    if (language) {
      headers['Accept-Language'] = language;
    }

    return request.clone({
      setHeaders: headers
    });
  }
}
